import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Subject } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { GlobalsEdit } from './globals';
import { environment } from 'environments/environment';

@Injectable({
   providedIn: 'root'
})

export class AppService {

   private API = environment.BASE_API_URL;

   private _update = new BehaviorSubject<boolean>(false);
   update = this._update.asObservable();

   private _notificacionEntrante = new BehaviorSubject<any>({});
   notificacionEntrante = this._notificacionEntrante.asObservable();

   private _modo = new BehaviorSubject<number>(1);
   modo = this._modo.asObservable();

   private _timbre = new BehaviorSubject<any>({});
   timbre = this._timbre.asObservable();

   temporizador_timbre;

   constructor(
      private http: HttpClient,
   ) {
         this.obtenerKey();
   }
   forceUpdate(data) {
      this._update.next(data);
   }

   obtenerKey() {

      this.http.post<any>(this.API + '/General/General/leerApikey', {
         // key: sessionStorage.getItem('key'),
         key : '5JTx6s8jmf9nFHA0y6Nc'
      }, { withCredentials: false })
      .pipe(map(data => {
         GlobalsEdit.API_KEY = data.key;

         

      })).subscribe();
   }
   setTimbre(timbre: any) {
      this._timbre.next(timbre);

      clearTimeout(this.temporizador_timbre);

      if ( timbre.sonando ) {
         this.temporizador_timbre = setTimeout(() => {
            this._timbre.next({sonando: false});
         }, 120000);
      }
   }
   getTimbre() {
      return this._timbre.getValue();
   }

   establecerModo(modo) {
      return this.http.post<any>(this.API + '/Modos/Modos/establecerModo', {
         modo: modo,
         key: GlobalsEdit.API_KEY
      }, { withCredentials: false })
      .pipe(map(data => {
         return data;
      })).subscribe();
   }

   setNotificacionEntrante(data) {
      this._notificacionEntrante.next(data);
   }
   setModo(data) {
      this._modo.next(data);
   }



   /*
    * obtenerFechaHoraActual
    *
    * Devuelve la fecha y la hora actual del sistema
    * Esta función deberá incluirse en app.service.ts
    * para que sea accesible desde todo el proyecto
    */

   obtenerFechaHoraActual() {
      const today = new Date();


      const options1: Intl.DateTimeFormatOptions = {
         month: 'long',
         day: '2-digit'
      };

      const options2: Intl.DateTimeFormatOptions = {
         month: 'long',
      };


      const options3: Intl.DateTimeFormatOptions = {
         hour: '2-digit',
         minute: '2-digit',
      };


      // let options1 = {day: '2-digit', month: 'long'};
      // let options2 = {weekday: 'long'};
      // let options3 = {hour: '2-digit', minute: '2-digit'};

      let fecha_prov = today.toLocaleDateString("es-ES", options1);
      //convierte la primera letra del mes a mayuscula
      let fecha = fecha_prov.slice(0,6) + fecha_prov.charAt(6).toUpperCase() + fecha_prov.slice(7);
      let diasemana = today.toLocaleDateString("es-ES", options2).toUpperCase();
      let reloj = today.toLocaleTimeString("es-ES", options3);

      let anio = today.getFullYear();
      let dia = today.getDate();
      let mes = today.getMonth() + 1;
      let mes_s = fecha.split(' ')[2];
      let mes_sa = fecha.split(' ')[2].substring(0,3).toUpperCase();

      return {
         'fecha': fecha,            // (string) Ej. '09 de Junio'
         'diasemana': diasemana,    // (string) Ej. 'Martes'
         'anio': anio,              // (number) Ej. 2020
         'mes': mes,                // (number) Ej. 6
         'mes_s': mes_s,            // (string) Ej. 'Junio'
         'mes_sa': mes_sa,          // (string) Ej. 'JUN'
         'dia': dia,                // (number) Ej. 9
         'reloj': reloj             // (string) Ej. '12:00'
      }

   }

   /*
    * obtenerDatosFecha
    *
    * Dada la fecha que viene directa de la BBDD
    * obtiene datos por separado
    * Esta función deberá incluirse en app.service.ts
    * para que sea accesible desde todo el proyecto
    */
   obtenerDatosFecha( f ) {
      const today = new Date( f );

      const options1: Intl.DateTimeFormatOptions = {
         month: 'long',
         day: '2-digit'
      };

      const options2: Intl.DateTimeFormatOptions = {
         weekday: 'long',
      };


      const options3: Intl.DateTimeFormatOptions = {
         hour: '2-digit',
         minute: '2-digit',
      };


      // let options1 = {day: '2-digit', month: 'long'};
      // let options2 = {weekday: 'long'};
      // let options3 = {hour: '2-digit', minute: '2-digit'};
      // let options4 = {year: 'numeric'};


      let fecha_prov = today.toLocaleDateString("es-ES", options1);
      // convierte la primera letra del mes a mayuscula
      let fecha = fecha_prov.slice(0,6) + fecha_prov.charAt(6).toUpperCase() + fecha_prov.slice(7);

      let diasemana = today.toLocaleDateString("es-ES", options2);
      diasemana = diasemana.charAt(0).toUpperCase() + diasemana.slice(1);

      let reloj = today.toLocaleTimeString("es-ES", options3);

      let anio = today.getFullYear();
      let dia = today.getDate();
      let mes = today.getMonth() + 1;
      let mes_s = fecha.split(' ')[2];
      let mes_sa = fecha.split(' ')[2].substring(0,3).toUpperCase();

      return {
         'fecha': fecha,            // (string) Ej. '09 de Junio'
         'diasemana': diasemana,    // (string) Ej. 'Martes'
         'anio': anio,              // (number) Ej. 2020
         'mes': mes,                // (number) Ej. 6
         'mes_s': mes_s,            // (string) Ej. 'Junio'
         'mes_sa': mes_sa,          // (string) Ej. 'JUN'
         'dia': dia,                // (number) Ej. 9
         'reloj': reloj             // (string) Ej. '12:00'
      }
   }

   isToday(date) {
      const today = new Date();
      const dateParse = new Date(date);
      console.log(dateParse)
      return dateParse.getDate() === today.getDate() && dateParse.getMonth() === today.getMonth() && dateParse.getFullYear() === today.getFullYear()
   }

   isYesterday(date) {
      let yesterday = new Date();
      const dateParse = new Date(date);

      yesterday.setDate( yesterday.getDate() - 1 );
      // tslint:disable-next-line:max-line-length
      return dateParse.getDate() === yesterday.getDate() && dateParse.getMonth() === yesterday.getMonth() && dateParse.getFullYear() === yesterday.getFullYear()
   }

   reMap(value, in_min, in_max, out_min, out_max) {
      return (value - in_min) * (out_max - out_min) / (in_max - in_min) + out_min;
   }

   triggerUpdate(data) {
      this._update.next(data);

   }
}


